import Tos_202609 from '@/pages/help/Tos_202609.vue'
import Tos_202411 from '@/pages/help/Tos_202411.vue'
import Privacy_202609 from '@/pages/help/Privacy_202609.vue'
import Privacy_202504 from '@/pages/help/Privacy_202504.vue'
import KidsPrivacy_202609 from '@/pages/help/KidsPrivacy_202609.vue'
import KidsPrivacy_202411 from '@/pages/help/KidsPrivacy_202411.vue'

/**
 * 약관 문서별 버전 목록.
 * versions 배열의 첫 번째 항목이 현재(최신) 약관이며, 나머지가 '이전 약관 보기'에 노출된다.
 * 새 버전을 추가할 때는 배열 맨 앞에 { value, label, component } 를 추가하면 된다.
 *  - value: URL 에 사용되는 시행일 (YYYYMMDD)
 *  - label: 드롭다운에 노출되는 시행일
 */
export const DOC_VERSIONS = {
    tos: {
        basePath: '/cn/tos',
        versions: [
            { value: '20260909', label: '2026年09月09日', component: Tos_202609 },
            { value: '20241029', label: '2024年10月29日', component: Tos_202411 },
        ],
    },
    privacy: {
        basePath: '/cn/privacy',
        versions: [
            { value: '20260909', label: '2026年09月09日', component: Privacy_202609 },
            { value: '20241029', label: '2024年10月29日', component: Privacy_202504 },
        ],
    },
    kidsPrivacy: {
        basePath: '/cn/privacy/kids',
        versions: [
            { value: '20260909', label: '2026年09月09日', component: KidsPrivacy_202609 },
            { value: '20241029', label: '2024年10月29日', component: KidsPrivacy_202411 },
        ],
    },
}

export function getDoc(docKey) {
    return DOC_VERSIONS[docKey]
}

export function getVersions(docKey) {
    const doc = getDoc(docKey)
    return doc ? doc.versions : []
}

/** 현재 시행 중인(= 목록 맨 앞) 약관. 요청된 버전과 구분하기 위해 latest 로 부른다. */
export function getLatestVersion(docKey) {
    return getVersions(docKey)[0]
}

export function findVersion(docKey, value) {
    if (!value) return getLatestVersion(docKey)
    return getVersions(docKey).find(v => v.value === value)
}

/** 최신 버전은 기본 경로를, 이전 버전은 기본 경로 + 시행일을 사용한다. */
export function getVersionPath(docKey, value) {
    const doc = getDoc(docKey)
    if (!doc) return '/'
    const latest = getLatestVersion(docKey)
    if (!value || (latest && value === latest.value)) return doc.basePath
    return `${doc.basePath}/${value}`
}
